import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getTest: {
    method: 'GET',
    url: `${configs.baseUrl}/api/ab/?testCode={testCode}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getTest = (testCode, params) => {
  return resource.getTest({ testCode }, params)
}

export default {
  initResource,
  getTest,
}
